import client from '../httpClient';

// sendmail019
const postSendLibraryMails = (params) => {
  return client.post('/send-mails/library', params);
};

export default postSendLibraryMails;
